module.exports = __webpack_public_path__ + "static/media/img-02.ffda86d4.jpg";